import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=22bf85db&scoped=true"
import script from "./DrawerMenu.vue?vue&type=script&lang=js"
export * from "./DrawerMenu.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenu.vue?vue&type=style&index=0&id=22bf85db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf85db",
  null
  
)

export default component.exports